import React from 'react';
import { useTranslation } from 'react-i18next';
import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';
import Button from '@wix/da-shared-react/pkg/Button';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';

import s from './SearchPageHeader.scss';

export interface Props {
  estTotal?: number;
  mainContentUrl?: string;
}

const SEE_ALL_BI_EVENT_DATA = {
  evid: BiEventType.SEE_ALL_CLICK,
};

const SearchPageHeader: React.FC<Props> = ({ estTotal, mainContentUrl }) => {
  const { t } = useTranslation();
  const isDeviationsTitleALink = Boolean(mainContentUrl);
  return (
    <>
      <div className={s['deviations-header']}>
        <div className={s['deviations-title-container']}>
          <span className={s['deviations-title']}>
            {isDeviationsTitleALink ? (
              <BiLink href={mainContentUrl} biData={SEE_ALL_BI_EVENT_DATA}>
                {t('facetPage.deviationsTitle')}
              </BiLink>
            ) : (
              t('facetPage.deviationsTitle')
            )}
          </span>
          <span className={s['deviations-count']}>
            {shortenNumber(estTotal)}
          </span>
        </div>
        {mainContentUrl && (
          <Button
            view="b33"
            href={mainContentUrl}
            className={s['deviations-all']}
            biData={SEE_ALL_BI_EVENT_DATA}
            fullWidth={false}
          >
            {t('facetPage.strip.all')}
          </Button>
        )}
      </div>
    </>
  );
};
SearchPageHeader.displayName = 'SearchPageHeader';

export default SearchPageHeader;
